//cardapio-online\libs\components\inputs\src\lib\lib-input-texto\input-texto.component.ts
import { Component } from '@angular/core';
import { InputGLobal } from '../utils/input-global';

@Component({
  selector: 'lib-input-texto',
  templateUrl: './input-texto.component.html',
  styleUrl: './input-texto.component.scss',
})
export class InputTextoComponent extends InputGLobal {

}
